import { Component, EventEmitter, Input, OnChanges, OnInit, Output, inject } from '@angular/core';
import {FormatService} from 'src/app/services/format.service';
import {agGridLanguageFr} from '../custom-ag-grid-languages';
import {Event} from '../../../model/event/event.model';
import {Observable} from 'rxjs';
import {DomLayoutType, GridApi, GridOptions} from "@ag-grid-community/core";
import { AgGridModule } from '@ag-grid-community/angular';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-grid-event-multi-select',
    templateUrl: './grid-event-multi-select.component.html',
    styleUrls: ['./grid-event-multi-select.component.scss'],
    imports: [NgIf, AgGridModule, AsyncPipe]
})
export class GridEventMultiSelectComponent implements OnInit, OnChanges {
  private readonly formatService = inject(FormatService);


  @Input() eventList: Event[] = [];
  @Output() selectionChange = new EventEmitter();

  @Input() defaultSelection: Event[];

  rowClassRules;
  columnEventDefs;
  isEventLoading = true;
  gridEventOptions: GridOptions;
  rowData: Observable<{
    id: number,
    eventType: string,
    age: string
  }[]> = null;
  domLayout: DomLayoutType = 'autoHeight';
  context;
  langue = agGridLanguageFr;
  paginationSize = 10;
  gridEventApi: GridApi;

  ngOnInit() {

      this.columnEventDefs = [
          {
              headerName: 'Type',
              field: 'eventType',
              sortable: true,
              headerCheckboxSelection: true,
              checkboxSelection: true
          },
          {
              headerName: 'Tranche',
              field: 'age',
              sortable: true
          }
      ];

      this.context = {componentParent: this};

      // init grid event
      this.gridEventOptions = {
          defaultColDef: {
              // make all cols more narrow
              width: 100,
              resizable: true,
              filter: false,
              domLayout: 'autoHeight',
              sortable: false
          },
          suppressMenuHide: true,
          floatingFilter: true,

          overlayLoadingTemplate: 'Chargement des données...',
          overlayNoRowsTemplate: 'Aucune donnée',

          enableRangeSelection: true,
          rowDragManaged: false,
          headerHeight: 50,
          rowHeight: 60,

          isRowSelectable: node => {
              return !!node.data;
          }
      } as GridOptions;
  }

  // Event grid
  onGridSizeChanged(params) {
      const grid = document.getElementById('grid-wrapper');
      if (grid) {
          const gridWidth = grid.offsetWidth;
          const columnsToShow = [];
          const columnsToHide = [];
          const allColumns = params.api.getAllColumns();
          let totalColsWidth = 0;
          if (allColumns) {
              allColumns.forEach(column => {
                  totalColsWidth += column.getMinWidth();
                  if (totalColsWidth > gridWidth) {
                      columnsToHide.push(column.colId);
                  } else {
                      columnsToShow.push(column.colId);
                  }
              });
          }
          params.api.setColumnsVisible(columnsToShow, true);
          params.api.setColumnsVisible(columnsToHide, false);
      }

      params.api.sizeColumnsToFit();
  }

  onEventGridReady(params) {
      this.gridEventApi = params.api;
      this.gridEventApi.sizeColumnsToFit();
      this.gridEventApi.setGridOption("suppressCellFocus", true);
      this.gridEventApi.setGridOption("suppressHorizontalScroll", true);
      this.gridEventApi.setGridOption("animateRows", true);
      this.setEventAffichage();
  }

  setEventAffichage() {
      if (this.gridEventApi) {
          this.gridEventApi.setGridOption("rowData", this.eventList ? this.eventList.map(value => this.getRowFromEvent(value)) : []);
      }
  }

  /**
   * Extrait les infos d'un event pour l'affichagé sur une ligne
   * @param event
   */
  getRowFromEvent(event: Event) {
      return {
          id: event.id,
          eventType: event.eventType,
          age: this.formatService.formatTrancheAge(event.session, true)
      };
  }

  onSelectionChanged() {
      this.selectionChange.emit(this.gridEventApi.getSelectedRows());
  }

  ngOnChanges(): void {
      this.setEventAffichage();
      if (this.eventList) {
          this.isEventLoading = false;
      }
  }
}
